import { Box, Table, TableBody, TableCell, TableHead, TablePagination, TableRow } from '@mui/material';

import { Person, PersonSortColumn, SortOrder } from '../types';
import { SortableTableHeader } from './SortableTableHeader';
import { SearchAndPagination } from './SearchAndPagination';

const stickyCellStyle: React.CSSProperties = {
  background: '#262626',
  fontWeight: 'bold',
  minWidth: 50,
  color: 'white',
  position: 'sticky',
  top: 0,
  zIndex: 100,
};

interface PersonsTableProps {
  persons: Person[];
  totalCount: number;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  sortColumn: PersonSortColumn;
  sortOrder: SortOrder;
  onSort: (column: PersonSortColumn) => void;
  page: number;
  rowsPerPage: number;
  onPageChange: (event: unknown, newPage: number) => void;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PersonsTable = ({
  persons,
  totalCount,
  searchQuery,
  onSearchChange,
  sortColumn,
  sortOrder,
  onSort,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}: PersonsTableProps) => {
  return (
    <Box>
      <SearchAndPagination
        searchQuery={searchQuery}
        onSearchChange={onSearchChange}
        totalCount={totalCount}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
      <Table stickyHeader size="small">
        <TableHead className="stickyTableHead">
          <TableRow sx={{ background: '#262626' }}>
              <SortableTableHeader
                label="ID"
                sortColumn="id"
                currentSortColumn={sortColumn}
                sortOrder={sortOrder}
                onSort={() => onSort('id')}
                stickyCellStyle={stickyCellStyle}
              />
              <SortableTableHeader
                label="Nom"
                sortColumn="name"
                currentSortColumn={sortColumn}
                sortOrder={sortOrder}
                onSort={() => onSort('name')}
                stickyCellStyle={stickyCellStyle}
              />
              <SortableTableHeader
                label="Prénom"
                sortColumn="first_name"
                currentSortColumn={sortColumn}
                sortOrder={sortOrder}
                onSort={() => onSort('first_name')}
                stickyCellStyle={stickyCellStyle}
              />
              <SortableTableHeader
                label="Nom de famille"
                sortColumn="last_name"
                currentSortColumn={sortColumn}
                sortOrder={sortOrder}
                onSort={() => onSort('last_name')}
                stickyCellStyle={stickyCellStyle}
              />
              <SortableTableHeader
                label="Email"
                sortColumn="email"
                currentSortColumn={sortColumn}
                sortOrder={sortOrder}
                onSort={() => onSort('email')}
                stickyCellStyle={stickyCellStyle}
              />
              <SortableTableHeader
                label="Téléphone"
                sortColumn="phone"
                currentSortColumn={sortColumn}
                sortOrder={sortOrder}
                onSort={() => onSort('phone')}
                stickyCellStyle={stickyCellStyle}
              />
              <TableCell sx={stickyCellStyle}>Org ID</TableCell>
              <SortableTableHeader
                label="Organisation"
                sortColumn="org_name"
                currentSortColumn={sortColumn}
                sortOrder={sortOrder}
                onSort={() => onSort('org_name')}
                stickyCellStyle={stickyCellStyle}
              />
              <TableCell sx={stickyCellStyle}>Owner ID</TableCell>
              <TableCell sx={stickyCellStyle}>Owner Name</TableCell>
              <SortableTableHeader
                label="Actif"
                sortColumn="active_flag"
                currentSortColumn={sortColumn}
                sortOrder={sortOrder}
                onSort={() => onSort('active_flag')}
                stickyCellStyle={stickyCellStyle}
              />
              <TableCell sx={stickyCellStyle}>Supprimé</TableCell>
              <SortableTableHeader
                label="Mis à jour"
                sortColumn="updated_at"
                currentSortColumn={sortColumn}
                sortOrder={sortOrder}
                onSort={() => onSort('updated_at')}
                stickyCellStyle={stickyCellStyle}
              />
            </TableRow>
          </TableHead>
          <TableBody>
            {persons.map((person) => (
              <TableRow key={person.id}>
                <TableCell>{person.id}</TableCell>
                <TableCell>{person.name}</TableCell>
                <TableCell>{person.first_name}</TableCell>
                <TableCell>{person.last_name}</TableCell>
                <TableCell>{person.email}</TableCell>
                <TableCell>{person.phone}</TableCell>
                <TableCell>{person.org_id}</TableCell>
                <TableCell>{person.org_name}</TableCell>
                <TableCell>{person.owner_id}</TableCell>
                <TableCell>{person.owner_name}</TableCell>
                <TableCell>{person.active_flag ? 'Oui' : 'Non'}</TableCell>
                <TableCell>{person.deleted_at ? 'Oui' : 'Non'}</TableCell>
                <TableCell>{person.updated_at ? new Date(person.updated_at).toLocaleString('fr-FR') : '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          padding: 2,
        }}
      >
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
          labelRowsPerPage="Lignes par page"
          labelDisplayedRows={({ from, to }) => `de ${from} à ${to}`}
        />
      </Box>
    </Box>
  );
};

